<template>
  <div class="text-4xl leading-relaxed font-serif font-bold">
    <slot />
  </div>
</template>
